<template>
  <div
    :class="[
      'product-attributes-toggle-fi',
      isBlock ? 'product-attributes-toggle-fi--is-block' : '',
      shopType ? `product-attributes-toggle-fi--${shopType}` : '',
    ]"
  >
    <span class="product-attributes-toggle-fi__label">
      {{ $dict.get('product-List.General.Approvals-Switch') }}
    </span>
    <toggle-fi
      v-model="approvalsEnabled"
      class="product-attributes-toggle-fi__switch"
      @click="$emit('toggle-approvals')"
    />
  </div>
</template>

<script setup lang="ts">
import { ToggleFi } from 'atoms';
import { computed } from 'vue';

import { useProductListStore } from '@/store/pinia/product-list';

defineOptions({ name: 'ProductAttributesToggleFi' });

withDefaults(
  defineProps<{
    isBlock?: boolean;
  }>(),
  {
    isBlock: false,
  },
);

defineEmits<{
  (e: 'toggle-approvals'): void;
}>();

const productListStore = useProductListStore();

const shopType = computed(() => productListStore.shopType);
const approvalsEnabled = computed({
  get: () => productListStore.approvalsEnabled,
  set: (state: boolean) => productListStore.setApprovalsEnabled(state),
});
</script>

<style scoped src="./product-attributes-toggle-fi" />
